import * as React from "react";

// Styles
import "./Container.scss";

interface Container {
  children: React.ReactNode;
  className?: string;
}

const Container: React.FC<Container> = (props: Container) => {
  const { children, className } = props;

  return (
    <div
      className={`layout-container w-full flex-grow mx-auto max-w-screen-xl pt-4 ${
        className || ""
      }`}
      style={{ paddingBottom: "40px" }}
    >
      {children}
    </div>
  );
};

export default Container;
